module.exports = __webpack_public_path__ + "img/13.5af54f4.png";